import { AbstractControl, ValidatorFn } from '@angular/forms';

type AtLeastOneRequiredOptions = {
  labels?: string[];
};

export function atLeastOneRequiredValidator(
  controlNames: string[],
  triggerControl?: string,
  options: AtLeastOneRequiredOptions = {},
): ValidatorFn {
  const { labels } = options;
  return (group: AbstractControl) => {
    const controls = controlNames.map((name) => ({ name, ctrl: group.get(name) })).filter((c) => !!c.ctrl) as {
      name: string;
      ctrl: AbstractControl;
    }[];
    const shouldValidate = !triggerControl || !!group.get(triggerControl)?.value;

    if (!group || !shouldValidate || !controls?.length) {
      controls?.forEach(({ ctrl }) => {
        clearError(ctrl);
      });
      return null;
    }

    const message = $localize`:formError|At least one field is required@@atLeastOneRequired: Tenminste één van deze velden is verplicht: ${(labels ?? controlNames).join(', ')}.`;
    const anyFilled = controls.some(({ ctrl }) => ctrl.value != null && ctrl.value !== '');
    controls.forEach(({ ctrl }) => {
      if (!anyFilled) {
        ctrl.setErrors({ ...(ctrl.errors ?? {}), atLeastOneRequired: { message } });
      } else {
        clearError(ctrl);
      }
    });
    return anyFilled ? null : { atLeastOneRequired: true };
  };

  function clearError(ctrl: AbstractControl) {
    if (ctrl.errors?.['atLeastOneRequired']) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { atLeastOneRequired, ...rest } = ctrl.errors;
      ctrl.setErrors(Object.keys(rest).length ? rest : null);
    }
  }
}
